<template>
  <div class="price-quotation">
    <div class="content">
         
        <el-form class="prod-form" label-width="100px" size="small" >
          <div style="display:flex;align-items:center;justify-content: space-between;padding:10px;box-shadow:0px 2px #eee">
                <div v-if="!compName">询价<span style="color:#0989C5;"> {{inquiryTitle}} </span>报价信息：</div>
                <div v-if="compName"><span style="color:#0989C5;"> {{compName}} </span>报价信息：</div>
                
                <el-button @click="goBack" style="margin-bottom:18px;margin-right:100px;">返回</el-button>
          </div>
          <div style="display: flex;align-items:center;">
              <div class="form-content">
                <el-empty v-if="!quotationList.length" description="暂无报价数据"></el-empty>
                <!-- 报价信息 -->
                <el-card class="box-card" v-for="(item,idx) in quotationList" :key="idx">
                  <div slot="header" class="header">
                    <div style="margin-right:30px;">产品报价基本信息</div>
                    <div style="margin-right:30px;">报价状态：<span style="color:#e6a23c;">{{item.status == 2 ? '已成交': '待成交'}}</span></div>
                    <div style="margin-right:30px;">报价标题：{{item.deliveryProductNameModel}}</div>
                    <div style="margin-right:30px;">报价时间：{{item.createDate||''}}</div>
                    <div>有效期至：{{item.quotationValidityPeriod||''}}</div>
                    <div></div>
                    <!-- <div class="close-box"><i class="el-icon-circle-close item-close" style="color:red;"></i></div> -->
                  </div>
                <div style="display: flex;align-items:center;justify-content: space-between;">
                  <div> <div style="display: flex;align-items:center;">
                        <el-form-item label="报价公司名称" >
                          <div style="width: 500px;">{{item.createCompName|| '--'}}</div>
                        </el-form-item>
                        <el-form-item>
                          <el-button   type="primary" @click="goQuotationDetail(item)">报价详情</el-button>
                          <el-button   type="primary" @click="contactPerson(item)">联系报价方</el-button>
                          <el-button  v-if="item.status == '1'||item.Status =='1'"  type="primary" @click="handleConfirm(item)">确认已成交</el-button>
                          <!-- <el-button   type="primary" @click="goToLookFile(item)">查看附件</el-button> -->

                        </el-form-item>
                      </div>

                      <div style="display: flex;align-items:center;">
                        <el-form-item label="综合报价" >
                          <el-input v-model="item.comprehensiveQuotation"  type="text"  :readonly="true"  style="width:250px;"></el-input>
                        </el-form-item>
                        <el-form-item label="报价单位" >
                          <el-input v-model="item.quotationUnit"  type="text" :readonly="true"  style="width:100px;"></el-input>
                        </el-form-item>
                        <el-form-item label="是否含税" >
                          <el-input v-model="item.isTaxIncluded"  type="text"  :readonly="true"  style="width:100px;"></el-input>
                        </el-form-item>
                        <el-form-item label="税率" >
                          <el-input v-model="item.taxRate"  type="text" :readonly="true"   style="width:100px;"></el-input>
                        </el-form-item>
                       
                      </div>
                      <div style="display: flex;align-items:center;">
                          <el-form-item label="付款方式" >
                            <el-input v-model="item.paymentMethod"  type="text" :readonly="true"   style="width:250px;"></el-input>
                          </el-form-item>
                          <el-form-item label="联系人" >
                          <el-input v-model="item.contactName"  type="text" :readonly="true"   style="width:200px;"></el-input>
                        
                        </el-form-item>
                        <el-form-item label="联系电话" >
                          <el-input v-model="item.contactPhone"  type="text" :readonly="true"  style="width:200px;"></el-input>
                        </el-form-item>
                      </div>
                    </div>

                    <!-- <div style="text-align: right;"><img src="https://img2cdn.global-dsc.cn/images/2024/01/46ea587cd81b47c0a8f01335151a422a_165x165.jpg" /></div> -->
                  </div>
                
                </el-card>
              </div>
          </div>
        </el-form>
    </div>
  </div>
</template>

<script>
import {MessageBox,Message} from 'element-ui'
// import {WinForm,CheckLibs} from '@digital-supply-chain/module'
import {Category, DomainService} from '@/libs'
import {UserService,OpenService, ApiService, PriceQuiryService, ChatService} from '@/service'


export default {
  data() {
    return {
        inquiryTitle: '',
        quotationList: [],
        compName: '',
        compId: '',
        formData: {
        inquiryTitle: '',
      },
    }
  },
  components: {  },
  mounted() {
   this.inquiryTitle = this.$route.query.inquiryTitle;
   this.compName = this.$route.query?.compName || '';
   this.compId = this.$route.query?.compId || '';

    // 进页面请求一次
    this.getData();
    // this.getQuoteInfoList();
    // this.getInquiryDetail()
  },
  methods: {

    getData() {
      const compId = this.$route.query.compId;
      if(compId) {
        this.getQuoteInfoList();
      }else {
        this.getInquiryDetail();
      }
    },
    
    // 获取询价列表数据
    async getInquiryDetail() {
      this.quotationList = [];
      const id = this.$route.query.id;
      const res = await PriceQuiryService.getInquiryDetail({id});
      this.quotationList = res?.data?.quoteInfo || []

    },

    // 已成交的报价
    async getQuoteInfoList() {
      const compId = this.$route.query.compId;
      this.quotationList = [];
      const res = await PriceQuiryService.getQuoteInfoList({companyId: compId});
      this.quotationList = res?.data?.list||[]
    },
     // 跳转 报价详情
    goQuotationDetail(row) {
      console.log(row, 'row')
      this.$router.push({
        path: '/quotation/detail', 
        query: { 
          id: row.id,
        }
      });
    },

    // 联系报价方 /message-record/20:${option.userId}
    contactPerson(item) {
      ChatService.StartRecent(Category.User, item.createUser)
    },
    handleConfirm(item) {
      MessageBox.confirm('确认报价已成交！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(()=> {
        this.sureCompleted(item);
      })
    },
    // 报价成功接口
    async sureCompleted(item) {
      console.log(item, 'quoteInfo')
      const res = await PriceQuiryService.saveInquirySucceed({id: item.id});
      if(res.code == 0) {
        Message.success('提交成功！')
        this.goBack();
      }
    },

    goBack() {
      this.$router.push({
        path: '/priceInquiry/home',
        query: {
          dirType: this.$route.query.dirType||'1',
        }
        
      });
   },

   goToLookFile(item) {
    console.log(item)
   }

    
  }
}
</script>

<style lang="less" scoped>

.left-dir{
  height: calc(100vh - 20px);
  overflow-y: auto;
  border-right: 6px solid #F2F2F2;
  max-width: 500px;
  min-width: 230px;
  cursor: ew-resize;
  display: flex;
  flex-direction: column;
  /deep/ .tree-span[data-id = "0"] {
    font-weight: bold;
    color: #606266;
  }
  /deep/ .tree-span[data-id = "-1"] {
    font-weight: bold;
    color: #606266;
  }
}
.header {
  display: flex;
  position: relative;
  .item-close {
    font-size: 30px;
    color: red;
  }
  .close-box {
    cursor: pointer;
    position: absolute;
    bottom: -50px;
    right: -10px;
  }
}

.iquiry-card {
  ::v-deep .el-form-item__label {
    width: 150px !important;
  }
  ::v-deep .el-form-item__content {
    margin-left: 150px !important;
  }
}

.content {
    flex: 1;
    overflow-x: hidden;
    // height: calc(100vh - 20px);
    // overflow-y: auto;
    ::v-deep .el-form-item.width-name label.el-form-item__label {
    font-size: 16px ;
    font-weight: 600;
  }
  ::v-deep .el-card__header {
    background: #eee;
    padding: 10px;
    color: #409EFF;
  }
  .footer {
    padding: 20px;
    text-align: right;
  }
}
.form-content {
  flex: 1;
  height: calc(100vh - 60px);
    overflow-y: auto;
}



.price-quotation{
  display: flex;
  flex-direction: row;
  flex: 1;
  background: #ffffff;
  box-shadow: 0px 6px 20px 0px rgba(0, 0, 0, 0.1);
  /deep/ .el-divider--horizontal{
    margin: 0;
  }
}
.box-card {
  margin-top: 10px;
  width: 100%;
  ::v-deep .el-card__body {
  padding: 10px;
}
}

</style>
